module.exports = __webpack_public_path__ + "img/causa-cesta.0c20cb4d.jpeg";